import { Alert, Button } from 'antd';
import { StyledActivityTryFeedback } from './ActivityTryFeedback.styled';
import typeLabel from '@/constants/ActivityTypeLabelsStudents';
import ProgressFeedback from '../../ProgressFeedback/ProgressFeedback';
import CustomText from '@/shared/Typography/Text';

export default function ActivityTryFeedback({
  taskActivity,
  visible,
  actions,
  dueDate,
  savingProgress,
  syncError,
}) {
  const completedTries = getCompletedTries(taskActivity?.progresses);
  const repetitions = taskActivity?.activityConf?.options?.repetitions;
  const activityFinished = completedTries >= repetitions;

  return (
    <StyledActivityTryFeedback visible={visible}>
      {activityFinished && (
        <h1>
          Congratulations! <span className="ml">🎉</span>
        </h1>
      )}
      <div className="feedback">
        <CustomText className="text-feedback">
          You have completed {completedTries} of {repetitions} for the "
          {taskActivity?.activity?.name}"{' '}
          {typeLabel(
            taskActivity?.activity.type,
            taskActivity?.activity.data.subType,
            taskActivity?.activityConf.miniactivityType
          )}
          .
        </CustomText>
      </div>
      <div className="repetitions-feedback" span={3}>
        <ProgressFeedback
          repetitions={taskActivity?.activityConf?.options?.repetitions}
          activityProgress={taskActivity?.activityProgress}
          showCorrect={taskActivity?.activityConf?.correctness}
          dueDate={dueDate}
          isStudent
          onlyGraph
        />
      </div>
      <div className="feedback-actions">
        <Button
          key="continue"
          type="primary"
          size="large"
          onClick={activityFinished ? actions.closeFeedback : actions.repeat}
          disabled={savingProgress}
          loading={savingProgress}
        >
          {savingProgress ? 'Saving progress...' : 'Continue'}
        </Button>
        {syncError ? (
          <Alert
            type="warning"
            message="The progress was saved in Rockalingua but it wasn't correctly saved in Google Classroom"
            description="You can continue but please warn your teacher about this issue."
          />
        ) : null}
      </div>
    </StyledActivityTryFeedback>
  );
}

function getCompletedTries(progresses) {
  return progresses?.reduce(
    (acc, progress) => acc + (progress.data.progress == 100 ? 1 : 0),
    0
  );
}
